// extracted by mini-css-extract-plugin
export var bottomCircle = "bG_gJ";
export var content = "bG_cf";
export var description = "bG_dx";
export var hide = "bG_B";
export var icon = "bG_bw";
export var image = "bG_k";
export var imageContainer = "bG_gN";
export var left = "bG_bL";
export var nextYear = "bG_gM";
export var right = "bG_bQ";
export var section = "bG_j";
export var shrink = "bG_gL";
export var title = "bG_d";
export var topCircle = "bG_gH";
export var wave = "bG_f3";
export var waveContainer = "bG_fl";
export var year = "bG_gK";